var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216,81.39H143.74v11.1h9.64a2.5,2.5,0,0,1,0,5H102.64a2.5,2.5,0,0,1,0-5h9.64V81.39H40a7.26,7.26,0,0,0-7.26,7.25V196.47A7.26,7.26,0,0,0,40,203.72h8.77V184.38c0-13.66,9.33-22.84,23.25-22.84a2.54,2.54,0,0,1,1.85.81l12.76,14.06,11.77-14a2.5,2.5,0,0,1,1.91-.88c14.29,0,24.28,9.39,24.28,22.84v19.34H216a7.26,7.26,0,0,0,7.25-7.25V88.64A7.26,7.26,0,0,0,216,81.39ZM106.71,132.7a20,20,0,1,1-40,0v-6.6a20,20,0,1,1,40,0Zm93.46,40H143.33a2.5,2.5,0,0,1,0-5h56.84a2.5,2.5,0,0,1,0,5Zm0-40H143.33a2.5,2.5,0,0,1,0-5h56.84a2.5,2.5,0,0,1,0,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.71,126.1v6.6a15,15,0,1,1-30,0v-6.6a15,15,0,1,1,30,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.74,77.78a2.39,2.39,0,0,0-.26,1.11,2.34,2.34,0,0,0,.26,1.09V92.49H117.28V52.28h21.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.61,184.38v19.34H53.79V184.38c0-10.48,6.7-17.37,17.16-17.81l13.91,15.31a2.49,2.49,0,0,0,3.76-.08l12.85-15.23C110.68,167,119.61,172.54,119.61,184.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.0dcc74803ca77747582f727a66f6782c.svg";
export { ForwardRef as ReactComponent };